import { Stack, styled } from "@mui/material";
import React from "react";
import CustomSearchInput from "@/components/custom/custom-search-input";
import CustomSelectInput from "@/components/custom/custom-select-input";
import { useSearchParams } from "react-router-dom";
import { DataTable } from "@/components/custom/data-table";
import CustomPagination from "@/components/custom/custom-pagination";
import { useMerchantTeams } from "@/hooks/use-merchant-teams";
import { useMerchantTeamRoles } from "@/hooks/use-merchant-team-roles";
import { formatRole } from "@/utils/format-role";
import { TeamsColumns } from "../_components/teams-column";

const SectionRoot = styled("section")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Teams = () => {
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";
  const invitorId = searchParams.get("invitorId");
  const roleName = searchParams.get("roleName");

  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const queryParams = {
    page: currentPage,
    size: pageSize,
    invitorId: invitorId ? invitorId : undefined,
    roleName: roleName ? roleName : undefined,
    search: searchValue,
  };

  const {
    data: teams,
    isLoading,
    isError,
  } = useMerchantTeams(true, queryParams);

  const { data: roles } = useMerchantTeamRoles();

  const roleOptions =
    roles?.data?.map((item) => ({
      label: formatRole(item.role),
      value: item.role,
    })) ?? [];

  return (
    <SectionRoot>
      <Card>
        <Stack direction={"row"} spacing={3}>
          <CustomSearchInput
            paramKey="search"
            placeholder="Search team members..."
          />
          <CustomSelectInput
            paramKey="roleName"
            label="Roles"
            placeholder="All Roles"
            options={roleOptions}
          />
        </Stack>

        <DataTable
          columns={TeamsColumns}
          data={teams?.data ?? []}
          isLoading={isLoading}
          isError={isError}
        />
        <CustomPagination
          total={teams?.total_count ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>
    </SectionRoot>
  );
};

export default Teams;
